import * as React from "react";
import {useLocation, Navigate, NavigateFunction} from "react-router-dom";
// import {NavigateFunction} from "react-router-dom";
import {ROUTES} from "../../helpers/constants";
import {AxiosInstance} from "../../api/axiosInstance";

export const checkRedirect = async (params: {navigate: NavigateFunction}, response: any) => {
  const {navigate} = params;
  console.log("params", params);
  if (typeof response === "object" && (response?.response?.status === 401)) {
    setToken("");
    // window.location.href = "/login.html";
    return navigate(ROUTES.login)
  }
  return false
}

export function getToken() {
  let sessionToken;
  try {
    sessionToken = window.sessionStorage.getItem('sessionToken');
  } catch (e) {
    console.log("error getting sessionToken");
  }
  // return JSON.parse(sessionToken)
  return sessionToken
}

export function setToken(token: string) {
  try {
    window.sessionStorage.setItem('sessionToken', token);
    // console.log("AxiosInstance", AxiosInstance);
    AxiosInstance.defaults.headers.post['Authorization'] = "Bearer " + token;
    AxiosInstance.defaults.headers.get['Authorization'] = "Bearer " + token;
    window.dispatchEvent(new CustomEvent("authchange", { detail: { token } }));
  } catch (e) {
    console.log("error setting sessionToken");
  }
}

export default function RequireAuth({ children }: { children: JSX.Element }) {

  const sessionToken = getToken();
  let location = useLocation();

  if (!sessionToken) {
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />;
    // window.location.href = "/login.html";
    return null;
  } else {
    if (!AxiosInstance.defaults.headers.get.Authorization) {
      setToken(sessionToken);
    }
    return children;
  }
}